import { t } from "i18next"
import { LanguageValues } from "@/types/__generated__/union-types"

const createPatientSteps = [
  {
    stepNumber: 0,
    label: "patient.create.steps.COVERAGE",
    id: "coverage-step" as const,
  },
  {
    stepNumber: 1,
    label: "patient.create.steps.IDENTIFY_CALLER",
    id: "identify-caller-step" as const,
  },
  {
    stepNumber: 2,
    label: "patient.create.steps.CONTACT",
    id: "contact-info-step" as const,
  },
  {
    stepNumber: 3,
    label: "patient.create.steps.CALL_REASON",
    id: "call-reason-step" as const,
  },
]

const CALLER_ROLE_ITEMS = [
  { value: "PATIENT", label: t("common.callerRoleList.PATIENT") },
  { value: "DOMESTIC_PARTNER", label: t("common.callerRoleList.MARITAL_PARTNER") },
  { value: "FATHER", label: t("common.callerRoleList.FATHER") },
  { value: "MOTHER", label: t("common.callerRoleList.MOTHER") },
  { value: "SON", label: t("common.callerRoleList.SON") },
  { value: "DAUGHTER", label: t("common.callerRoleList.DAUGHTER") },
  { value: "GRANDFATHER", label: t("common.callerRoleList.GRANDFATHER") },
  { value: "GRANDMOTHER", label: t("common.callerRoleList.GRANDMOTHER") },
  { value: "PHARMACY", label: t("common.callerRoleList.PHARMACY") },
  { value: "OTHER", label: t("common.callerRoleList.OTHER") },
]

const CALLER_LANGUAGE_PREFERENCE_ITEMS = LanguageValues.map((value) => ({
  value,
  label: t(`common.languageList.${value.toLowerCase()}`),
}))

type StepId = (typeof createPatientSteps)[number]["id"]

type TStep = (typeof createPatientSteps)[number]

const getActiveStepNumber = (steps: TStep[], id: StepId) => steps.find((step) => step.id === id)?.stepNumber

const PHONE_COUNTRY_CODE_PREFIX_MIN_LENGTH = 3
const PHONE_NUMBER_MIN_LENGTH = 10

const TelephonySearchParams: Record<string, string> = {
  PhoneNumber: "phonenumber",
  CallLine: "call-line",
  KidsLine: "Kids line",
  Country: "country",
  Record: "record",
  CallId: "CallID",
  Language: "Lang",
  PayLine: "PL",
}

const PATIENT_COUNTRY_FILTER_ITEMS = [
  { value: "DE", label: "common.countryList.DE" },
  { value: "CH", label: "common.countryList.CH" },
] as const

const EMAIL_MAX_LENGTH = 254

export {
  createPatientSteps,
  CALLER_ROLE_ITEMS,
  CALLER_LANGUAGE_PREFERENCE_ITEMS,
  getActiveStepNumber,
  type TStep,
  PHONE_COUNTRY_CODE_PREFIX_MIN_LENGTH,
  PHONE_NUMBER_MIN_LENGTH,
  TelephonySearchParams,
  PATIENT_COUNTRY_FILTER_ITEMS,
  EMAIL_MAX_LENGTH,
}
